import { render, staticRenderFns } from "./veStuScholarshipShow.vue?vue&type=template&id=622a83de&scoped=true"
import script from "./veStuScholarshipShow.vue?vue&type=script&lang=js"
export * from "./veStuScholarshipShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a83de",
  null
  
)

export default component.exports